(() => {
 const setup = (root=document) => {
  root.querySelectorAll('[data-foundlab-description]').forEach(details => {
   if(details.dataset.foundlabReady) return;
   const scope=details.closest('.Product__Info');
   const origin=scope?.querySelector('[data-foundlab-description-origin]');
   const destination=scope?.querySelector('[data-foundlab-description-destination]');
   if(!origin || !destination) return;
   details.dataset.foundlabReady='true';
   const mobile=window.matchMedia('(max-width:1007px)');
   const arrange=() => {if(mobile.matches){destination.append(details);details.open=false;}else{origin.after(details);details.open=true;}};
   arrange(); mobile.addEventListener('change',arrange);
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
 document.addEventListener('shopify:section:load',event=>setup(event.target));
})();

(() => {
 const tidy = value => value.replace(/(\d)[\u2013\u2014](?=\d)/g, '$1 to ').replace(/[\u2013\u2014]/g, ', ').replace(/!/g, '.').replace(/\s+/g, ' ').trim();
 const setupFacts = root => {
  root.querySelectorAll('[data-foundlab-product-facts]').forEach(target => {
   const scope = target.closest('.Product__Info');
   const description = scope?.querySelector('[data-foundlab-description]');
   if (!description || target.childElementCount) return;
   const source = description.cloneNode(true);
   source.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
   const lines = [...source.querySelectorAll('p, li, h2, h3, h4, h5, h6')].flatMap(node => node.textContent.split('\n')).map(tidy).filter(Boolean);
   let fabric = '';
   let fit = '';
   for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (!fabric && /^(fabric(?: composition)?|material)\s*:/i.test(line)) {
     fabric = line.replace(/^(fabric(?: composition)?|material)\s*:\s*/i, '');
    }
    if (!fabric && /^\d+(?:\.\d+)?\s*%/.test(line)) fabric = line.split(/(?<=[.!])\s+/)[0];
    if (!fit && /^fit(?: details| & sizing)?(?=\s|:|$)\s*:?/i.test(line)) {
     fit = line.replace(/^fit(?: details| & sizing)?(?=\s|:|$)\s*:?\s*/i, '');
     if (!fit && lines[i + 1]) fit = lines[i + 1];
     fit = fit.split(/(?<=[.!])\s+/)[0];
    }
   }
   if (!fabric) {
    const materials = /\d+(?:\.\d+)?\s*%\s*(?:bamboo\s+silk|Italian\s+linen|silk|polyester|viscose|lurex|cotton|linen|rayon|wool|cashmere|elastane|nylon|spandex)/gi;
    const compositionLine = lines.find(line => { materials.lastIndex = 0; return materials.test(line); });
    if (compositionLine) fabric = [...new Set(compositionLine.match(materials) || [])].join(', ');
   }
   for (const [label, value] of [['Fabric', fabric], ['Fit', fit]]) {
    if (!value || value.length > 240) continue;
    const line = document.createElement('p');
    line.textContent = `${label}: ${value}`;
    target.append(line);
   }
   target.hidden = !target.childElementCount;
  });
 };
 const setupSizes = () => {
  if (!/\/pages\/size\/?$/.test(location.pathname)) return;
  const content = document.querySelector('.PageContent.Rte');
  if (!content) return;
  content.querySelectorAll('table').forEach((table, index) => {
   if (table.closest('details')) return;
   const wrapper = table.parentElement.classList.contains('TableWrapper') ? table.parentElement : table;
   let heading = wrapper.previousElementSibling;
   const text = heading ? tidy(heading.textContent) : '';
   const hasHeading = heading && /^(H[2-6]|P)$/.test(heading.tagName) && text.length > 0 && text.length < 100;
   const details = document.createElement('details');
   details.className = 'foundlab-size-table';
   const summary = document.createElement('summary');
   const tableTitle = tidy(table.rows[0]?.cells[0]?.textContent || '');
   summary.textContent = tableTitle || (hasHeading ? text : `Size table ${index + 1}`);
   wrapper.before(details);
   details.append(summary, wrapper);
   if (hasHeading && (!tableTitle || text === tableTitle)) heading.remove();
  });
 };
 const setup = (root = document) => { setupFacts(root); setupSizes(); };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
 document.addEventListener('shopify:section:load', event => setup(event.target));
})();
